import useCancelAppointment from "@/services/appointment/hooks/useCancelAppointment";
import {
  Alert,
  Button,
  Group,
  Modal,
  Stack,
  Text,
  Textarea,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import * as Yup from "yup";

const schema = Yup.object().shape({
  cancellationDescription: Yup.string().required("توضیحات اجباری می باشد"),
});

type Props = {
  open: boolean;
  close: () => void;
  appointmentId: number;
};

function CancelAppointment({ close, open, appointmentId }: Props) {
  const form = useForm<{ cancellationDescription: string }>({
    validate: yupResolver(schema),
    initialValues: {
      cancellationDescription: "",
    },
  });

  const { mutate, isLoading } = useCancelAppointment();
  return (
    <Modal onClose={close} opened={open} title="کنسل کردن نوبت">
      <Stack>
        <Alert color="yellow" title="توجه:">
          <Text size="xs" ta="justify">
            همه نوبت‌های این رزرو لغو می‌شود. اگر بیعانه با اسنپ‌پی پرداخت شده
            باشد، تراکنش اسنپ‌پی هم لغو می‌شود. برای سایر پرداخت‌ها، بازگرداندن
            وجه یا تغییر ساعت با آرایشگاه است و پدیکس مسئولیتی در قبال عودت مبلغ
            ندارد.
          </Text>
        </Alert>

        <form
          onSubmit={form.onSubmit((values) => {
            mutate(
              {
                appointmentId: appointmentId,
                cancellationDescription: values?.cancellationDescription,
              },
              {
                onSuccess() {
                  form.reset();
                  close();
                },
              }
            );
          })}
          className="w-100"
        >
          <Stack>
            <Textarea
              withAsterisk
              placeholder="توضیحات"
              description="برای کنسل کردن نوبت لطفا توضیحاتی ارائه دهید."
              {...form.getInputProps("cancellationDescription")}
              rows={4}
            ></Textarea>
            <Group>
              <Button type="submit" color="red" loading={isLoading}>
                کنسل
              </Button>
              <Button
                variant="outline"
                onClick={close}
                loading={isLoading}
              >
                انصراف
              </Button>
            </Group>
          </Stack>
        </form>
      </Stack>
    </Modal>
  );
}

export default CancelAppointment;
